import { DefaultButton, Icon } from "@fluentui/react";
import { emptyFunc } from "../../home/models/OtherTypes";

export type FilterButtonProps = {
    text: string;
    onDelete: emptyFunc;
}

export default function FilterButton({ text, onDelete }: FilterButtonProps) {
    return <>
        <DefaultButton
            text={text}
            className="filter-text"
            onClick={onDelete}
        >
            {onDelete !== null && <Icon iconName={'SkypeCircleMinus'} />}
        </DefaultButton>
    </>;
}